import { Box, Image } from "@chakra-ui/react";
import accordion_images from "../../../utils/accordion/accordion_images";

const ExperientialAccordion = ({
  isExperientialLearning,
  isCustomAssessment,
  isChapterEndAssessment,
  isExperientialTask,
  isMobile,
  onClick,
}) => {
  if (!isExperientialLearning || isCustomAssessment || isChapterEndAssessment) {
    return null;
  }

  return (
    <Box gap={"8px"} display={"flex"}>
      {isExperientialTask && (
        <Image
          src={accordion_images.experientialTaskButton}
          onClick={() => {
            onClick("ExperientialTask");
          }}
          width={isMobile && "100px"}
          alt="Experiential Homework"
        />
      )}
      <Image
        src={accordion_images.experientialLearningButton}
        onClick={() => {
          onClick("Experiential");
        }}
        width={isMobile && "80px"}
        alt="Experiential Homework"
      />
    </Box>
  );
};

export default ExperientialAccordion;
